import { render, staticRenderFns } from "./tab-icons-2.vue?vue&type=template&id=3ca7e496&scoped=true"
import script from "./tab-icons-2.vue?vue&type=script&lang=js"
export * from "./tab-icons-2.vue?vue&type=script&lang=js"
import style0 from "./tab-icons-2.vue?vue&type=style&index=0&id=3ca7e496&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7e496",
  null
  
)

export default component.exports